import {Grid, Box} from '@primer/react-brand/esm'
import type {ReactNode} from 'react'

function SupportGridRoot({children}: {children: ReactNode}) {
  return (
    <Grid style={{paddingInline: 0}}>
      <Grid.Column>
        <Box
          borderColor="muted"
          borderStyle="solid"
          borderInlineEndWidth={{regular: 'thin'}}
          borderInlineStartWidth={{regular: 'thin'}}
        >
          <Grid
            style={{
              '--brand-Grid-spacing-row': '0',
              '--brand-Grid-spacing-column-gap': '0',
            }}
          >
            {children}
          </Grid>
        </Box>
      </Grid.Column>
    </Grid>
  )
}

function SupportGridItem({children, index, total}: {children: ReactNode; index: number; total: number}) {
  const isMiddle = index > 0 && index < total - 1

  return (
    <Grid.Column span={{xsmall: 12, medium: 4}}>
      <Box
        padding={{narrow: 32, regular: 8, wide: 32}}
        borderColor="muted"
        borderStyle="solid"
        borderBlockEndWidth={{narrow: 'thin', regular: 'none'}}
        borderBlockStartWidth={{narrow: index > 0 ? 'thin' : 'none', regular: 'none'}}
        borderInlineEndWidth={{regular: isMiddle ? 'thin' : 'none'}}
        borderInlineStartWidth={{regular: isMiddle ? 'thin' : 'none'}}
        style={{height: '100%'}}
      >
        {children}
      </Box>
    </Grid.Column>
  )
}

export const SupportGrid = Object.assign(SupportGridRoot, {Item: SupportGridItem})
